// client/extensions/EditExtensionData.ts
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { XNativeDialog } from "@adornis/dialog/x-native-dialog.js";
import { stateful, useState } from "@adornis/functional-lit/stateful.js";
import { html, nothing } from "lit";
import "../../db/GlobalSettings.js";
import { Size } from "../globals/enums.js";
import { copyContent } from "../globals/methods.js";
var EditExtensionData = stateful(
  ({
    host,
    content,
    globalSettings,
    extensions,
    hideDefaultEditor = true
  }) => {
    if (!content || !globalSettings || !extensions || !content.controller)
      return nothing;
    const extension = content.extension ?? extensions.find((d) => d.class._class === content.value._class);
    if (!extension)
      return nothing;
    content.controller.registerDefaults(extension.defaultValues, content.path);
    const [lastSelectedBaseTemplate, setLastSelectedBaseTemplate] = useState(void 0);
    const [appendNewItemsOfBaseTemplate, setAppendNewItemsOfBaseTemplate] = useState(true);
    const renderBaseTemplates = () => {
      const templates = globalSettings.baseTemplates.filter((d) => d.template._class === content.value._class);
      if (!templates.length)
        return nothing;
      return html`
        <x-flex space="md">
          <x-text>Templates</x-text>
          <x-dropdown-selection
            .value=${lastSelectedBaseTemplate}
            .selectables=${templates}
            .renderString=${(d) => d.name}
            @value-picked=${(e) => {
        setLastSelectedBaseTemplate(e.detail.value);
      }}
          ></x-dropdown-selection>
          ${lastSelectedBaseTemplate ? html`
                <x-checkbox
                  .label=${"Neue Elemente anh\xE4ngen"}
                  .value=${appendNewItemsOfBaseTemplate}
                  @value-picked=${(e) => {
        setAppendNewItemsOfBaseTemplate(e.detail.value);
      }}
                ></x-checkbox>
                <x-button
                  @click=${async () => {
        if (!await XNativeDialog.confirm(
          "Wollen Sie dieses Template wirklich \xFCbernehmen? Alle bisherigen Einstellungen werden \xFCberschrieben!"
        ))
          return;
        if (!lastSelectedBaseTemplate || !content.value || !extensions)
          return;
        const copiedContent = copyContent({
          content: [],
          extensions,
          instanceToCopy: lastSelectedBaseTemplate.template
        });
        for (const key of Object.keys(copiedContent.toObject())) {
          if (["parentID", "subItemID", "index", "_id"].includes(key))
            continue;
          if (appendNewItemsOfBaseTemplate && Array.isArray(copiedContent[key]) && Array.isArray(content.value[key])) {
            content.value[key].push(...copiedContent[key]);
          } else {
            content.value[key] = copiedContent[key];
          }
        }
        setLastSelectedBaseTemplate(void 0);
        setAppendNewItemsOfBaseTemplate(true);
        host.requestUpdate();
      }}
                >
                  Template übernehmen
                </x-button>
              ` : nothing}
        </x-flex>

        <x-hr></x-hr>
      `;
    };
    return xComponents(html`
      <x-flex space="md">
        ${renderBaseTemplates()}
        ${extension.editor ? extension.editor({
      content: content.value,
      contentController: content.controller,
      controllerBaseKeyPath: content.path,
      host,
      globalSettings,
      extensions
    }) : html`
              <generated-form
                .formController=${content.controller}
                .placeholderMode=${"inline-floating"}
                .blacklist=${["index", "parentID", "configs", "subItemID", ...Object.values(Size)]}
              ></generated-form>
            `}
        ${hideDefaultEditor ? nothing : html`
              <x-buildify-default-editor
                .controller=${content.controller}
                .controllerPath=${content.path}
              ></x-buildify-default-editor>
            `}
      </x-flex>
    `);
  }
);
export {
  EditExtensionData
};
